import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { DashboardLayoutComponent } from './layouts/dashboard/dashboard-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () => {
      return import('./pages/auth-pages/auth.module').then((m) => {
        return m.AuthModule;
      });
    },
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    loadChildren: () => {
      return import('./pages/dashboard-pages/dashboard.module').then((m) => {
        return m.DashboardModule;
      });
    },
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
